module.exports = __webpack_public_path__ + "static/media/appQuiz.e7b140ae.svg";